import request from "../../utils/request";

export const select = (params) => {
    return request({
        url: "/api/blade-plugins/platformapplycard/list",
        method: "post",
        data: params
    });
};

export const selectCards = (params) => {
    return request({
        url: "/api/blade-plugins/platformapplycard/detail?id="+params,
        method: "get",
        // data: params
    });
};

// 上传文件
export const uploadFile = (params) => {
    return request({
      url: "/api/blade-plugins/platformapplycard/upload",
      method: 'post',
      data: params,
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
  }

  export const selectTree = (params) => {
    return request({
        url: "/api/blade-plugins/platformapplycard/find/role?roleId="+params,
        method: "get",
        // data: params
    });
};

  export const selectlableTree = (params) => {
    return request({
        url: "/api/blade-plugins/platformapplycard/find/lable?lableId="+params,
        method: "get",
        // data: params
    });
};

export const add = (params) => {
    return request({
        url: "/api/blade-plugins/platformapplycard/saveOrUpdate",
        method: "post",
        data: params
    });
};
//停止
export const stop = (params) => {
    return request({
        url: "/api/blade-plugins/platformapplycard/stop",
        method: "post",
        data: params
    });
};
//启动
export const start = (params) => {
    return request({
        url: "/api/blade-plugins/platformapplycard/start",
        method: "post",
        data: params
    });
};
//卸载
export const uninstall = (params) => {
    return request({
        url: "/api/blade-plugins/platformapplycard/uninstall",
        method: "post",
        data: params
    });
};
//下载版本包
export const download = (params) => {
    return request({
      url: '/api/blade-plugins/platformapplycard/down?id='+params,
      method: 'get'
    })
  }

export const savaupgrade = (params) => {
    return request({
        url: "/api/blade-plugins/platformapplycard/update",
        method: "post",
        data: params
    });
};
